import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sig_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const BUSINESS = {
  name: "Sudeeksha Invisible Grills",
  shortName: "Sudeeksha",
  city: "Hyderabad",
  phone: "7032507529",
  phoneDisplay: "+91 70325 07529",
  whatsapp: "917032507529",
  email: "sudeekshamylapalli58@gmail.com",
};
